// extracted by mini-css-extract-plugin
export default {"position":"style-module--position--nCUbx","removeBorder":"style-module--removeBorder--I-v2i"};